var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMetamask = function SvgIcnMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.51 22.98 3.67.972V22.68l.299-.3h2.096v2.545h-2.246l-2.77-1.197-1.048-.749Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.49 22.98-3.594.972V22.68l-.3-.3H14.5v2.545h2.246l2.77-1.197.973-.749Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.479 20.21-.3 2.47.374-.3h3.893l.45.3-.3-2.47-.599-.375-2.994.075-.524.3Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.457 3.518 1.797 4.192.824 12.2h2.92l.898-12.2 1.647-4.192h-8.086Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.596 12.725.5 18.787l5.24-.299h3.37v-2.62l-.15-5.389-.749.599-5.615 1.647Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m6.564 13.398 6.14.15-.674 3.144-2.92-.749-2.546-2.545Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m6.564 13.473 2.546 2.395v2.396l-2.546-4.79Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m9.11 15.943 2.994.749.974 3.219-.675.374-3.293-1.946v-2.396Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m9.11 18.338-.6 4.641 3.969-2.77-3.37-1.87Z",
    fill: "#EB8F35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m12.703 13.548.375 6.362-1.123-3.256.748-3.106Z",
    fill: "#EA8E3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m5.666 18.413 3.444-.075-.6 4.641-2.844-4.566Z",
    fill: "#D87C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m2.147 25 6.364-2.021-2.845-4.566-5.166.374L2.147 25Z",
    fill: "#D87C30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m12.254 7.71-3.22 2.694-2.47 2.994 6.14.225-.45-5.914Z",
    fill: "#E8821E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m8.51 22.98 3.969-2.77-.3 2.395v1.348l-2.695-.524-.973-.45ZM20.49 22.98l-3.894-2.77.3 2.395v1.348l2.695-.524.898-.45Z",
    fill: "#DFCEC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m11.056 14.896.824 1.72-2.92-.748 2.096-.973Z",
    fill: "#393939"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m2.072 0 10.182 7.71-1.721-4.192L2.073 0Z",
    fill: "#E88F35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.072 0 .725 4.116l.748 4.492-.524.299.749.674-.6.524.824.748-.523.449 1.198 1.497 5.615-1.721s4.117-3.293 4.043-3.368C12.18 7.635 2.072 0 2.072 0Z",
    fill: "#8E5A30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m26.404 12.725 2.096 6.062-5.24-.299h-3.37v-2.62l.15-5.389.749.599 5.615 1.647Z",
    fill: "#F89D35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m22.436 13.398-6.14.15.675 3.144 2.92-.749 2.545-2.545Z",
    fill: "#D87C30"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m22.436 13.473-2.546 2.395v2.396l2.546-4.79Z",
    fill: "#EA8D3A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m19.89 15.943-2.994.749-.974 3.219.675.374 3.293-1.946v-2.396Z",
    fill: "#F89D35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m19.89 18.338.6 4.641-3.894-2.694 3.294-1.947Z",
    fill: "#EB8F35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m16.297 13.548-.375 6.362 1.123-3.256-.748-3.106Z",
    fill: "#EA8E3A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m23.334 18.413-3.444-.075.6 4.641 2.844-4.566Z",
    fill: "#D87C30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m26.853 25-6.364-2.021 2.845-4.566 5.166.374L26.853 25Z",
    fill: "#D87C30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m16.746 7.71 3.22 2.694 2.47 2.994-6.14.225.45-5.914Z",
    fill: "#E8821E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m17.944 14.896-.824 1.72 2.92-.748-2.096-.973Z",
    fill: "#393939"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.928 0 16.746 7.71l1.722-4.192L26.928 0Z",
    fill: "#E88F35"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m26.928 0 1.347 4.116-.748 4.492.524.299-.749.674.6.524-.825.748.524.449-1.198 1.497-5.615-1.721s-4.117-3.293-4.043-3.368C16.82 7.635 26.928 0 26.928 0Z",
    fill: "#8E5A30"
  })));
};
export default SvgIcnMetamask;